export default __webpack_public_path__ + "static/media/logout.7bf0f440.png";